import {
  AI_CHAT_ANSWER_ABANDONED,
  AI_CHAT_CREATED,
  AI_CHAT_MESSAGE_SENT,
  AI_CHAT_OPENED,
  BLOCKED_BY_FEATURE_GATE,
  DATADOG_ACTION_WHITELIST,
  EVENTS,
} from '@/lib/constants';
import { EventBus } from '@/lib/event-bus';
import { datadogRum } from '@datadog/browser-rum';
import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';
import { obfuscateText } from '@/lib/text';

export const registerEventListeners = () => {
  EventBus.$on(EVENTS.SESSION.LOGIN, ({ user, account }) => {
    datadogRum.setUser({
      id: user.uid,
      account: {
        id: account.uid,
        name: account.companyName,
        plan: account.accountSettings.planId,
      },
    });
    datadogRum.startSessionReplayRecording();
  });

  const endRumSession = () => {
    datadogRum.stopSessionReplayRecording();
    datadogRum.clearUser();
    datadogRum.stopSession();
  };
  EventBus.$on(EVENTS.SESSION.LOGOUT, endRumSession);
  EventBus.$on(EVENTS.SESSION.SWITCH_ACCOUNT, endRumSession);

  EventBus.$on(EVENTS.UPSELL.FEATURE_GATE_VIEWED, (flag) => {
    datadogRum.addAction(BLOCKED_BY_FEATURE_GATE, { featureFlag: flag });
  });

  EventBus.$on(EVENTS.AI_CHAT.CHAT_OPENED, ({ via }) => {
    datadogRum.addAction(AI_CHAT_OPENED, { via });
  });
  EventBus.$on(EVENTS.AI_CHAT.MESSAGE_SENT, ({ attachmentCount }) => {
    datadogRum.addAction(AI_CHAT_MESSAGE_SENT, { attachmentCount });
  });
  EventBus.$on(EVENTS.AI_CHAT.CHAT_CREATED, () => {
    datadogRum.addAction(AI_CHAT_CREATED, {});
  });
  EventBus.$on(EVENTS.AI_CHAT.ANSWER_ABANDONED, () => {
    datadogRum.addAction(AI_CHAT_ANSWER_ABANDONED, {});
  });
};

const rumActive = () => resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_ACTIVE) === 'true';

export const grantTrackingConsent = () => {
  if (rumActive()) {
    datadogRum.setTrackingConsent('granted');
  }
};

export const initDatadog = () => {
  if (rumActive()) {
    datadogRum.init({
      trackingConsent: 'not-granted',
      applicationId: resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_APPLICATION_ID),
      clientToken: resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_CLIENT_TOKEN),
      site: 'datadoghq.eu',
      env: resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_ENVIRONMENT),
      service: resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_SERVICE_NAME),
      version: resolveEnvironmentVariable(environmentVariable.DATADOG_RUM_SERVICE_VERSION),
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackViewsManually: true,
      defaultPrivacyLevel: 'mask',
      startSessionReplayRecordingManually: true,
      /* eslint-disable no-useless-escape */
      allowedTracingUrls: [/https?:\/\/app\.mooncamp\.com/],
      /* eslint-enable no-useless-escape */
      // eslint-disable-next-line consistent-return
      beforeSend: (event) => {
        // redact action name from click actions
        if (event.type === 'action' && DATADOG_ACTION_WHITELIST[event.action.target.name] === undefined) {
          event.action.target.name = obfuscateText(event.action.target.name, 2, 2);
        }
        if (event.view) {
          event.view.url = event.view.url.replace(/s=[.\w-]+/, 's=masked');
        }
        return true;
      },
    });

    registerEventListeners();
  }
};
